var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('span',{staticClass:"grey--text"},[_vm._v("Upcoming Hoilday on ")]),_vm._v(" "+_vm._s(_vm.date)),_c('br'),_c('span',{staticClass:"headline font-weight-light"},[_vm._v(_vm._s(_vm.occasion))])])}
var staticRenderFns = []

export { render, staticRenderFns }